export default __webpack_public_path__ + "static/media/jokerPokerEmetyCard.55bb7c00.svg";